// import Bootstrap
import 'bootstrap';

// import custom JS
import './misc';
import './slick-custom';
import './theme-switcher';
import './email-service';
import './contact-us-form';
import './toggle-nav';

// Libs
import './libs/horizontal-timeline-master/main';
import './libs/horizontal-timeline-master/custom';
import './libs/map-libre/maps';
